/**
 * @generated SignedSource<<391c5246bb7bd41a7640876b3fe99d96>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type main_issueNavigator_IssueNavigatorUI_spreadsheetView$data = {
  readonly viewSettings: {
    readonly isGroupingEnabled: boolean | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"main_issueNavigator_Header_spreadsheetViewResult" | "topBar_issueNavigator_spreadsheetViewResult">;
  readonly " $fragmentType": "main_issueNavigator_IssueNavigatorUI_spreadsheetView";
};
export type main_issueNavigator_IssueNavigatorUI_spreadsheetView$key = {
  readonly " $data"?: main_issueNavigator_IssueNavigatorUI_spreadsheetView$data;
  readonly " $fragmentSpreads": FragmentRefs<"main_issueNavigator_IssueNavigatorUI_spreadsheetView">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "main_issueNavigator_IssueNavigatorUI_spreadsheetView",
  "selections": [
    {
      "concreteType": "JiraIssueSearchViewConfigSettings",
      "kind": "LinkedField",
      "name": "viewSettings",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isGroupingEnabled"
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "main_issueNavigator_Header_spreadsheetViewResult"
    },
    {
      "kind": "FragmentSpread",
      "name": "topBar_issueNavigator_spreadsheetViewResult"
    }
  ],
  "type": "JiraSpreadsheetView",
  "abstractKey": "__isJiraSpreadsheetView"
};

(node as any).hash = "049a7f131ccdd259ab75e73fa7e68000";

export default node;
